import { useEffect, useState } from "react";
import "./EXHIHomeView.css";

import { doFetchJson } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import ExhibitionWorkspace from "Projects/CC_cubi_clan_project/GlobalComponents/ExhibitionWorkspace/ExhibitionWorkspace";

export default function EXHIHomeView({ hostAppCode, onLoading }) {
  const [role, setRole] = useState(null);

  useEffect(() => {
    loadRole();
  }, []);

  async function loadRole() {
    console.log(`[EXHI:Home] loadRole \u2014 hostAppCode=${hostAppCode ?? "standalone"}`);
    try {
      const data = await doFetchJson("EXHI", "my-role", { method: "GET" });
      console.log("[EXHI:Home] loadRole \u2014 respuesta:", JSON.stringify(data?.DATA ?? data, null, 2));
      if (data && data.STATE === "SUCCESS") {
        const { isAdmin, isManager, registeredApps = [], currentUserId = 0 } = data.DATA;
        console.log(`[EXHI:Home] loadRole \u2014 isAdmin=${isAdmin} isManager=${isManager} registeredApps=[${registeredApps.join(",")}] userId=${currentUserId}`);
        setRole(data.DATA);
      } else {
        console.warn("[EXHI:Home] loadRole \u2014 STATE no es SUCCESS:", data?.STATE, data?.MESSAGE);
      }
    } catch (e) {
      console.error("[EXHI:Home] loadRole \u2014 ERROR:", e);
      toast.show({ message: "Error al verificar permisos", type: "danger" });
    }
  }

  // Sin rol todavía: no renderizar
  if (!role) return null;

  const { isAdmin, isManager, registeredApps = [], currentUserId = 0 } = role;

  // Acceso y creación: misma regla.
  // Modo embebido: requiere permiso en hostAppCode. Modo standalone: requiere permiso en "EXHI".
  const hasAccess = isAdmin || isManager ||
    (hostAppCode ? registeredApps.includes(hostAppCode) : registeredApps.includes("EXHI"));
  if (!hasAccess) {
    return (
      <div className="exhi-home exhi-no-access">
        <h3>Sin acceso</h3>
        <p>No tienes permisos para acceder a las exhibiciones de esta aplicación.</p>
      </div>
    );
  }

  // Puede editar/eliminar cualquier exhibición del contexto (no solo las propias)
  const canManage = isAdmin || (isManager && (!hostAppCode || registeredApps.includes(hostAppCode)));

  return (
    <div className="exhi-home">
      <ExhibitionWorkspace
        onLoading={onLoading}
        hostAppCode={hostAppCode}
        canCreate={hasAccess}
        canManage={canManage}
        currentUserId={currentUserId}
        registeredApps={registeredApps}
      />
    </div>
  );
}

